import * as React from "react";

const SvgChild = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <mask
      id="child_svg__a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="currentColor" fillOpacity={0.92} d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#child_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13 2h-2v2h2zm-2 3h2v2h-2zm1 17-5-5 1.4-1.45 2.6 2.6V8h2v10.15l2.6-2.6L17 17z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default SvgChild;
